import React, { PropsWithChildren } from 'react';

import { useTailwindContainerBreakpoint } from '@swyftx/aviary/hooks/useTailwindContainerBreakpoint';

import { MarginTransactionsTable } from '@routes/SwyftxMargin/components/Trade/MarginPositionsCard/Tables';
import { TransactionHistoryStatuses } from '@routes/Transactions/types';

import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';

type Props = {
  statuses: TransactionHistoryStatuses[];
  startDate?: DateTime;
  endDate?: DateTime;
};

const TransactionsTransferTable: React.FC<PropsWithChildren<Props>> = observer(() => {
  const { isSmallScreen, isXs, isSm } = useTailwindContainerBreakpoint({ containerName: 'transactions-table-card' });

  return (
    <MarginTransactionsTable isDesktopView={!isSmallScreen} groupBy='assetTransferStatusDate' isSm={isSm} isXs={isXs} />
  );
});

export { TransactionsTransferTable };
